import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerPegSolitaireTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  PegSolitaireDefinition,
  PegSolitaireProgress,
  PegSolitaireSolution,
  PegSolitaireSubmission,
} from "./types";

registerPegSolitaireTranslations(i18n);

export const pegSolitaireModule: PuzzleTypeModule<
  PegSolitaireDefinition,
  PegSolitaireSubmission,
  PegSolitaireProgress,
  PegSolitaireSolution
> = {
  key: "peg_solitaire",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
